import React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter, Link } from 'react-router-dom';
import { enumText, translate } from '../../../../utils/util';
import { ENUMS } from '../../../../utils/constants';

const ListItemMission = (props) => {
    const getStatus = (value) => translate(`expedition:${enumText(ENUMS.eOrderItemStatus, value)}`);

    return (
        <li
            key={props.data.orderItemId}
            className="collection-item avatar z-depth-1"
            style={{ backgroundColor: 'white', color: 'black', minHeight: '100px' }}
        >
            <Link
                style={{ display: 'block' }}
                to={{ pathname: props.route }}
                state={props.data}
                onClick={(event) => {
                    if (props.onSelectChange) {
                        props.onSelectChange(event);
                    }
                }}
            >
                <div className="input-field col s12">
                    <strong><span className="title sixth-text-color">{`${props.data.location}`}</span></strong>
                    <br />
                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>{`${props.data.cim} - ${props.data.description}`}</span>
                    <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>{getStatus(props.data.status)}</span>
                </div>
            </Link>
        </li>
    );
}

export default withRouter((withTranslation()(ListItemMission)));
